import React, {Fragment} from "react";
import { Modal, Tooltip, List } from "antd";
import { WorkOrderList } from "../../../../models/workorder";
import {Config} from "../../../../controller/Global";

const BOL = Config.constant.service_type.bol;
const SERVICE = Config.constant.service_type.service;

export class ShowWorkOrder extends React.Component {
  state = {
    data: []
  };
  fetch = (ids) => {
    WorkOrderList({ ids: ids, depth: 4 })
      .then(response => {
        this.setState({ data: response.data.results })
      });
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.data !== prevProps.data)
      this.fetch(this.props.data)
  }

  render() {
    const { data } = this.state;
    const { visible } = this.props;
    return (
      <Modal title="View Details" centered visible={visible} onOk={() => this.props.setModelVisible()} onCancel={() => this.props.setModelVisible()} width='75%' className="view-data-modal" destroyOnClose={true}>
        {data.map(function (item, index) {
          return (
            <div key={index} className="row single-data-row">
              <div className="col-12 header-view-data">
                <div className="view-data-div">
                  <span>Work Order Number</span>
                </div>
                <div className="view-data-div">
                  <span>Generator <i className="fa fa-info-circle" /></span>
                </div>
                <div className="view-data-div">
                  <span>Bill To <i className="fa fa-info-circle" /></span>
                </div>
                <div className="view-data-div">
                  <span>Date</span>
                </div>
                <div className="view-data-div">
                  <span>PO <i className="fa fa-info-circle" /></span>
                </div>
              </div>
              <div className="view-data-row">
                <div className="col-12 quote-details">
                  <div className="view-data-div">
                    <span>{item.work_order_number}</span>
                  </div>
                  <div className="view-data-div">
                    <Tooltip placement="bottom" title={`${item.generator.address} ${item.generator.city} ${item.generator.zip_code}`}>
                      <span>{item.generator.company_name} {item.generator.account_number} </span>
                    </Tooltip>
                  </div>
                  <div className="view-data-div">
                    <Tooltip placement="bottom" title={`${item.bill_to.company_name} ${item.bill_to.account_number}`}>
                      <span>{item.bill_to.company_name} {item.bill_to.account_number} </span>
                    </Tooltip>
                  </div>
                  <div className="view-data-div">
                    <span>{item.date}</span>
                  </div>
                  <div className="view-data-div">
                    <Tooltip placement="bottom" title={item.po}>
                      <span>{item.po}</span>
                    </Tooltip>
                  </div>
                </div>
              </div>
                <div className="col-12 view-data-service">
                  <h6>Services</h6>
                  <div className="col-12 padding-0">
                    <List itemLayout="horizontal" dataSource={data} renderItem={item => (
                        <div key={item.id} className="demo-loadmore-list view-data-list dynamic-area list-type-view">
                          {item.service.map((service, index) => (
                            <List.Item.Meta key={index}
                              description={
                                <div className="added-services">
                                  <div className="row added-services-header">
                                    <span>{service.type} Number</span>
                                    <span>Service name</span>
                                    <span>Service Date</span>
                                    <span>Crew members</span>
                                    <span>Transporter</span>
                                    <span>Facility</span>
                                    <span>Truck Type</span>
                                  </div>
                                  <div className="row">
                                    <span>{service.manifest_number}</span>
                                    <span>{service.service_type.name}</span>
                                    <span>{service.service_date}</span>
                                    <span>{service.number_people}</span>
                                    <span>{service.transporter.name}</span>
                                    <span>{service.facility.name}</span>
                                    <span>{service.truck_type.map(truck => truck.type_name).join(', ')}</span>
                                  </div>
                                  <div className="row job-desc-view">
                                    <div className="col-12">
                                      <h4>Job Description:</h4>
                                       <Tooltip placement="top" title={service.job_description}>
                                          <p>{service.job_description?service.job_description.substring(0,100): '-'}</p>
                                       </Tooltip>
                                    </div>
                                  </div>
                                  {service.type !== SERVICE &&
                                  <Fragment>
                                    <div className="row added-services-header multiple-desc">
                                      <span className="quantity-serv ws-code">Code</span>
                                      <span className="description-serv">Description</span>
                                      <span className="quantity-serv">Quantity</span>
                                      <span className="quantity-serv">Unit</span>
                                      <span className="quantity-serv">Price</span>
                                      <span className="quantity-serv">Container</span>
                                    </div>
                                    <div className="row multiple-desc">
                                      {service.waste_data.map((stream, index) => {
                                        return <React.Fragment key={index}>
                                          <span
                                            className="quantity-serv ws-code">{stream.waste_stream ? stream.waste_stream.code : ''}</span>
                                          <Tooltip placement="bottom"
                                                   title={stream.waste_stream ? stream.waste_stream.description : ''}>
                                            <span
                                              className="description-serv info"> {stream.waste_stream ? stream.waste_stream.description : ''}</span>
                                          </Tooltip>
                                          <span className="quantity-serv">{stream.quantity}</span>
                                          <span
                                            className="quantity-serv">{stream.waste_stream ? stream.waste_stream.unit : ''}</span>
                                          <span className="quantity-serv">{stream.price}</span>
                                          <span
                                            className="quantity-serv">{stream.waste_stream ? stream.waste_stream.container ? stream.waste_stream.container.name : '' : ''}</span>
                                        </React.Fragment>
                                      })}
                                    </div>
                                  </Fragment>
                                  }
                                </div>} />
                          ))}
                        </div>
                    )} />
                  </div>
                </div>
            </div>
          )
        })}
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/tracks/workorder/popups/ShowWorkOrder.jsx